var map = {
	"./033-dinner.svg": 2396,
	"./24.svg": 1234,
	"./Arrow.svg": 1985,
	"./ArrowRightCard.svg": 1665,
	"./Question.svg": 4025,
	"./arrow-left-simple.svg": 196,
	"./arrow-right-simple.svg": 190,
	"./arrowLeft.svg": 4725,
	"./arrowRight.svg": 845,
	"./bedcard.svg": 5332,
	"./bedsvg.svg": 2547,
	"./breakfast.svg": 8564,
	"./checked.svg": 2173,
	"./close.svg": 420,
	"./conf.svg": 8074,
	"./date.svg": 3341,
	"./double_bed.svg": 1283,
	"./doubleuser.svg": 5489,
	"./dush.svg": 3402,
	"./forward.svg": 9162,
	"./kvadrat.svg": 9653,
	"./mark.svg": 1491,
	"./pet.svg": 6929,
	"./single_bed.svg": 3151,
	"./snow.svg": 8684,
	"./unchecked.svg": 8854,
	"./user-mini.svg": 4453,
	"./user.svg": 1816,
	"./vanna.svg": 8693,
	"./wallet.svg": 3740,
	"./warning-info.svg": 3782,
	"./wifi.svg": 5654,
	"./x-circle.svg": 5325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;